import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Small } from '@upsolve/ui';

import SCREENER_CTA_TYPES from '../analytics/screenerCtaTypes';
import HeroCtaWrapper from './HeroCtaWrapper.div';
import IconClockFast from '../../../static/images/icon-clock-fast.svg';
import IconHeartHand from '../../../static/images/icon-heart-hand.svg';
import IconPiggyBank from '../../../static/images/icon-piggy-bank.svg';
import getScreenerUrl from '../Links/getScreenerUrl';
import upsolveStats from '../../../content/onBuild/upsolveStats.json';
import { ButtonLink } from '../analytics/LinksWithOnClick';
import trackComponentImpression from '../analytics/trackComponentImpression';
import trackComponentAction from '../analytics/trackComponentAction';
import withViewportWatch from '../analytics/withViewportWatch';
import withGeoLocation from '../maps/withGeoLocation';

const trackingProps = {
  componentName: 'HeroFilerCta',
  componentVersion: 0,
};

/**
 * HeroFilerCta
 * - v0: Defaults
 * - v1: Geolocation on title: "We help {regionName} residents like you file bankruptcy for free." (reverted, poorer performance)
 *
 * @component
 * @version 0
 */
const HeroFilerCta = (props) => {
  const [impressionTracked, setImpressionTracked] = useState(false);
  const [numStars, setNumStarts] = useState(0);

  // On Mount
  useEffect(() => {
    axios.get(`${UPSOLVE_API_URL}/v1/stats/starts`)
      .then(({ data }) => setNumStarts(data.stats));
  }, []);

  // Impression Tracking
  if (props.isInViewport && !impressionTracked) {
    setImpressionTracked(true);
    props.stopWatcher();
    trackComponentImpression(trackingProps);
  }

  return (
    <HeroCtaWrapper>
      <div className="headline">
        Upsolve is a nonprofit that helps you file bankruptcy for free.
      </div>
      <div className="value-props">
        <ul>
          <li>
            <IconPiggyBank /> <span>We've helped {upsolveStats.filings.total} families each <b>clear on average ${upsolveStats.debtCleared.averagePerFiler.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })} of debt</b>.</span>
          </li>
          <li>
            <IconClockFast /> <span>Our users often file within 10 days of starting.</span>
          </li>
          <li>
            <IconHeartHand /> <span>Our nonprofit tool is 100% free, funded by generous donors.</span>
          </li>
        </ul>
      </div>
      <div className="action">
        <ButtonLink
          aria-busy="false"
          size="lg"
          href={getScreenerUrl({ cta: SCREENER_CTA_TYPES.SIDEBAR_HERO, contentGroup: props.contentGroup })}
          onClick={() => trackComponentAction({ ...trackingProps, actionId: 'heroFilerCta.screenerNavigation', actionMethod: 'click' })}
        >
          Get Started
        </ButtonLink>
      </div>
      <br />
      {numStars > 0 && (
        <div className="num-starts">
          <Small><u>{`${numStars} people have started`}</u> in the past week!</Small>
        </div>
      )}
    </HeroCtaWrapper>
  );
}

export default withViewportWatch(HeroFilerCta);
